module.exports = function() {
  return new Worker(__webpack_public_path__ + "685f636fd54c9f25b458.worker.js");
};